import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
    deleteFilterPAEAA014Conditions,
    fetchInitialConditions,
    saveFilterPAEAA014Conditions,
    saveMatchingConditions,
} from '../../../redux/reducers/PAEAA014';
import {
    getListCode,
    getPAAAA010recruit,
    getPAEAA010search,
    postPAEAA010list,
    putPAAAA010Banner,
} from '../../../services/Api';
import CheckBox from '../../../shared/components/Checkbox';
import Dropdown from '../../../shared/components/Dropdown';
import Nav from '../../../shared/components/Nav';

import PaginationCustom from '../../../shared/components/PaginationCustom';
import RecruitList from '../../../shared/components/RecruitList';
import GrandBanner from '../../../shared/GrandBanner';
import { MENU_RECRUIT, MESSAGE } from '../../../shared/constants/app';
import { decodeToken, getCheckBoxValues, getDropdownValue } from '../../../utils';
import PAEAA060 from '../PAEAA010/popupPAEAA060';
import store from '../../../redux/store';

const PAEAA014 = () => {
    const [loading, setLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const navigate = useNavigate();
    const [checkedLabels, setCheckedLabels] = useState([]);
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    const [subwayData, setSubwayData] = useState([]);
    const [subwayNum, setSubwayNum] = useState([]);
    const [subwayPost, setSubwayPost] = useState([]);
    const [filteredSubwayPost, setFilteredSubwayPost] = useState([]);
    const [selectedNum, setSelectedNum] = useState('');
    const [payload, setPayLoad] = useState({});

    const [recruitClass, setRecruitClass] = useState([]);
    const [recruitCommunes, setRecruitCommunes] = useState({});

    const [checkedValues, setCheckedValues] = useState({});
    const [applyMethod, setApplyMethod] = useState({});

    const [results, setResults] = useState([]);
    const [size, setSize] = useState(50);
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [sortBy, setSortBy] = useState('ModDate');
    const [keywords, setKeywords] = useState([]);
    const [dataSubway, setDataSubway] = useState(0);
    const [isSearch, setIsSearch] = useState(0);
    const [search, setSearch] = useState(0);
    const [num, setNum] = useState(null);
    const dispatch = useDispatch();

    const savedConditions = useSelector(({ PAEAA014 }) => PAEAA014.savedPAEAA014Conditions);
    const [savedConditionsPopup, setSavedConditionsPopup] = useState(false);

    const desctCodes = ['001', '002', '004', '005', '006'];
    const popupRef = useRef(null);

    const [recruitBanner, setRecruitBanner] = useState([]);
    const [searchSuccess, setSearchSuccess] = useState(false);
    const [dataConFig, setDataConFig] = useState({
        countFixed: '',
        bannerConfig: '',
    });
    useEffect(() => {
        getPAAAA010recruit()
            .then(({ data }) => {
                setRecruitBanner(data.recruit);
                const listSeq = [data.recruit?.map((item) => item.seq).join(',')].filter((seq) => seq).join(',');
                if (listSeq.toString() === '') return;
                putPAAAA010Banner(listSeq.toString())
                    .then()
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }, []);

    const getStructuredData = () => {
        if (!subwayNum || !subwayPost) return {};

        let structuredData = {};

        desctCodes.forEach((desct) => {
            structuredData[`subwayNum_${desct}`] = subwayNum
                .filter((num) => num.desct === desct)
                .map((num) => ({
                    code: num.code,
                    codeName: num.codeName,
                    desct: num.desct,
                    kind: num.kind,
                    subwayPost: subwayPost
                        .filter((post) => post.desct === num.code)
                        .map((post) => ({
                            code: post.code,
                            codeName: post.codeName,
                            desct: post.desct,
                            kind: post.kind,
                        })),
                }));
        });

        return structuredData;
    };

    const tabs = [
        { label: '수도권', icon: 'icon-location', isActive: true },
        { label: '부산', icon: 'icon-location', isActive: false },
        { label: '대구', icon: 'icon-location', isActive: false },
        { label: '광주', icon: 'icon-location', isActive: false },
        { label: '대전', icon: 'icon-location', isActive: false },
    ];
    const [active, setActive] = useState(tabs.findIndex((tab) => tab.isActive));
    const location = useLocation();

    const handleTabClick = (index) => {
        if (React.isValidElement(tabs[index].label)) {
            return;
        }
        setActive(index);
        handleTabChange(index);
    };

    const getOptions = (name) => {
        if (!subwayNum || !filteredSubwayPost) return [];

        const options = {
            SubwayNum: subwayNum.map((item) => ({
                id: 'subwayNum_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
            SubwayPost: filteredSubwayPost.map((item) => ({
                id: 'subwayPost_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
        };

        desctCodes.forEach((desct) => {
            options[`SubwayNum${desct}`] = subwayNum
                .filter((item) => item.desct === desct)
                .map((item) => ({
                    id: 'subwayNum_' + item.code,
                    label: item.codeName,
                    value: item.code,
                    desct: desct,
                }));
        });

        return options[name] || [];
    };

    const filterSubwayPost = (value) => {
        setFilteredSubwayPost(subwayPost.filter((item) => item.desct === value));
    };

    const handleNumClick = (value) => {
        filterSubwayPost(value);
        setSelectedNum(value);
    };

    const handleTabChange = (index) => {
        setActiveTabIndex(index);
    };

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'size':
                setSize(selectedValue);
                break;
            case 'sortBy':
                setSortBy(selectedValue);
                break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    // select box, radio box
    const handleInputChange = (e) => {
        const { name, value, checked, type, id } = e.target;

        setCheckedValues((checkedValues) => {
            let newCheckedValues = { ...checkedValues };

            if (type === 'checkbox' && name !== 'ApplyMethod') {
                newCheckedValues = getCheckBoxValues(newCheckedValues, name, value, checked);

                if (name === 'SubwayPost') {
                    const selectedSubwayNum = String(getCodeNameAndParentLabel(value).codeParent);

                    if (selectedSubwayNum) {
                        const SubwayNumCode = String(selectedSubwayNum);
                        const currentSubwayNum = newCheckedValues.SubwayNum
                            ? newCheckedValues.SubwayNum.map(String)
                            : [];

                        if (checked) {
                            if (!currentSubwayNum.includes(SubwayNumCode)) {
                                newCheckedValues.SubwayNum = [...currentSubwayNum, SubwayNumCode];
                            }
                        } else {
                            const remainingSubwayPost = newCheckedValues.SubwayPost || [];
                            const isSubwayNumStillRelevant = recruitCommunes[SubwayNumCode]?.some((commune) =>
                                remainingSubwayPost.includes(commune.code),
                            );

                            if (!isSubwayNumStillRelevant) {
                                newCheckedValues.SubwayNum = currentSubwayNum.filter((code) => code !== SubwayNumCode);
                                if (newCheckedValues.SubwayNum.length === 0) {
                                    delete newCheckedValues.SubwayNum;
                                }
                            }
                        }
                    }
                }
            }
            return newCheckedValues;
        });

        setApplyMethod((prevApplyMethod) => {
            let newApplyMethod = { ...prevApplyMethod };

            if (type === 'checkbox' && name === 'ApplyMethod') {
                const methodId = id;

                if (checked) {
                    if (!newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = [];
                    }

                    if (!newApplyMethod[methodId].includes(value)) {
                        newApplyMethod[methodId].push(value);
                    }
                } else {
                    if (newApplyMethod[methodId]) {
                        newApplyMethod[methodId] = newApplyMethod[methodId].filter((item) => item !== value);

                        // Nếu không còn value nào, xóa key methodId
                        if (newApplyMethod[methodId].length === 0) {
                            delete newApplyMethod[methodId];
                        }
                    }
                }
            }

            return newApplyMethod;
        });
    };
    const getCodeNameAndParentLabel = (code) => {
        for (const key in subwayData) {
            if (Array.isArray(subwayData[key])) {
                for (const item of subwayData[key]) {
                    const found = item.subwayPost.find((post) => post.code === code);
                    if (found) {
                        return {
                            child: found.codeName,
                            codeChild: found.code,
                            parent: item.codeName,
                            codeParent: item.code,
                        };
                    }
                }
            }
        }
        return null;
    };

    // get label
    const getCheckedLabels = () => {
        const labels = [];

        // Lấy label từ checkedValues
        Object.entries(checkedValues || {}).forEach(([key, values]) => {
            if (key === 'SubwayPost') {
                const valueArray = Array.isArray(values) ? values : [values];
                valueArray.forEach((value) => {
                    const codeName = getCodeNameAndParentLabel(value);
                    labels.push(`${codeName.parent} > ${codeName.child}`);
                });
            }
        });

        // Lấy label từ applyMethod
        const flatApplyMethodValues = Object.values(applyMethod || {}).flat();
        flatApplyMethodValues.forEach((value) => {
            const options = getOptions('ApplyMethod');
            const matchedOption = options.find((option) => option.value === value);
            if (matchedOption) {
                labels.push(matchedOption.label);
            }
        });

        if (keywords && keywords.length > 0) {
            keywords.forEach((keyword) => {
                labels.push(keyword);
            });
        }
        return labels;
    };

    // remove label
    const handleRemoveLabel = (label) => {
        setCheckedValues((prevValues) => {
            const newValues = { ...prevValues };
            const [subwayNumName, SubwayPostName] = label.split(' > ');

            // duyệt qua các key trong checkedValues
            Object.entries(newValues).forEach(([key, values]) => {
                // xử lý SubwayPost
                if (key === 'SubwayPost') {
                    setPayLoad(() => {
                        const { SubwayNum, SubwayPost, ...oldData } = checkedValues;

                        return {
                            ...oldData,
                            ...(subwayNum ? { SubwayNum: subwayNum } : {}),
                            ...(subwayPost ? { SubwayPost: subwayPost } : {}),
                        };
                    });
                    // tìm subwayNum liên kết với SubwayPost từ recruitCommunes
                    let result = [];

                    Object.values(subwayData || {}).forEach((subwayList) => {
                        subwayList.forEach((num) => {
                            if (num.codeName === subwayNumName) {
                                let matchedPosts = num.subwayPost.filter((post) => post.codeName === SubwayPostName);
                                if (matchedPosts.length > 0) {
                                    result.push({ ...num, subwayPost: matchedPosts });
                                }
                            }
                        });

                        if (subwayList) {
                            subwayList.forEach((num, index) => {
                                const subwayPostList = subwayList[index].subwayPost;
                                const subwayPostToRemove = subwayPostList.find(
                                    (item) => item.codeName === SubwayPostName,
                                );
                                if (subwayPostToRemove && Array.isArray(newValues.SubwayPost)) {
                                    newValues.SubwayPost = newValues.SubwayPost.filter(
                                        (code) => code !== subwayPostToRemove.code,
                                    );
                                    // nếu SubwayNum trống, xóa luôn key SubwayNum
                                    if (newValues.SubwayPost.length === 0) {
                                        delete newValues.SubwayNum;
                                        delete newValues.SubwayPost;
                                    }
                                }
                            });
                        }
                    });
                }
            });
            return newValues;
        });

        setApplyMethod((prevValues) => {
            const newValues = { ...prevValues };
            const options = getOptions('ApplyMethod');

            Object.entries(newValues).forEach(([key, values]) => {
                const valueArray = Array.isArray(values) ? values : [values];

                const matchedOption = options.find((option) => valueArray.includes(option.value));

                if (matchedOption && matchedOption.label === label) {
                    delete newValues[key];
                }
            });

            return newValues;
        });

        // xóa khỏi keywords và các trường 'CompanyName', 'Title', 'FTS_Contents'
        const isKeywordLabel = label && keywords.includes(label); // kiểm tra có trong keywords list không

        if (isKeywordLabel) {
            // xóa keyword khỏi `keywords` state
            const keywordToRemove = label;

            setKeywords((prevKeywords) => {
                return prevKeywords.filter((keyword) => keyword !== keywordToRemove);
            });
        }

        // xóa label khỏi danh sách `checkedLabels`
        setCheckedLabels((prevLabels) => prevLabels.filter((l) => l !== label));
    };

    useEffect(() => {
        if (loggedIn) {
            dispatch(fetchInitialConditions());
        }
    }, [dispatch, loggedIn]);

    const handleSaveConditions = () => {
        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login');
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
            return;
        }
        const savedDate = moment().format('YYYY/MM/DD');
        if (
            checkedValues &&
            Object.keys(checkedValues).length === 0 &&
            applyMethod &&
            Object.keys(applyMethod).length === 0 &&
            checkedLabels.length === 0
        )
            return;

        const currentConditions = store.getState().PAEAA014.savedPAEAA014Conditions;
        if (currentConditions.length >= 5) {
            window.alert('최대 저장가능한 개수는 5개 입니다.');
            return;
        }

        dispatch(
            saveFilterPAEAA014Conditions({
                subwayPost: checkedValues?.SubwayPost || null,
                subwayNum: checkedValues?.SubwayNum || null,
                applyMethod,
                savedDate,
                checkedLabels,
            }),
        );

        dispatch(saveMatchingConditions(decode.seq));

        window.alert(MESSAGE.notify.saveSuccess);
    };

    useEffect(() => {
        setActiveTabIndex(0);
    }, []);

    const handleResetConditions = () => {
        setCheckedValues({});
        setCheckedLabels([]);
        setKeywords([]);
        setApplyMethod({});
    };

    useEffect(() => {
        setCheckedLabels(getCheckedLabels);
        // eslint-disable-next-line
    }, [checkedValues, recruitClass]);

    useEffect(() => {
        getPAEAA010search()
            .then(({ data }) => {
                setRecruitCommunes(data.recruitCommunes);
                setRecruitClass(data.recruitClass);
            })
            .catch((error) => console.log(error));

        getListCode('A16,A17')
            .then(({ data }) => {
                setSubwayNum(data.A16);
                setSubwayPost(data.A17);
                setDataSubway(1);
            })
            .catch((error) => console.log(error));
    }, []);

    useEffect(() => {
        const structuredData = getStructuredData();
        setSubwayData(structuredData);
        // eslint-disable-next-line
    }, [subwayNum, subwayPost]);

    const getListData = () => {
        setLoading(true);
        setResults([]);
        const options = Object.keys(payload).length === 0 ? null : payload;
        const method = Object.keys(applyMethod).length === 0 ? null : applyMethod;
        postPAEAA010list({
            subwayNum: options?.subwayNum || null,
            subwayPost: Array.isArray(options?.subwayPost)
                ? options.subwayPost.filter((post) => post !== '100')
                : options?.subwayPost || null,
            applyMethod: method,
            size,
            page,
            sortBy,
        })
            .then(({ data }) => {
                setResults(data.data.list);
                setPages(data.info);
                setDataConFig({
                    countFixed: data.data.countFixed,
                    bannerConfig: data.data.bannerConfig,
                });
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(false);
                setSearchSuccess(true);
                setTimeout(() => setSearchSuccess(false), 2000);
            });
    };

    const handleSearchClick = () => {
        setIsSearch(1);
    };

    useEffect(() => {
        if (isSearch) {
            setPayLoad(() => {
                const { SubwayNum, SubwayPost, ...oldData } = checkedValues;

                return {
                    ...oldData,
                    ...(SubwayNum ? { subwayNum: SubwayNum } : {}),
                    ...(SubwayPost ? { subwayPost: SubwayPost } : {}),
                };
            });

            setSearch(1);
        }
        // eslint-disable-next-line
    }, [isSearch]);

    useEffect(() => {
        if (search) {
            setSearchParams((prev) => ({ ...prev, page: 1 }));
            getListData();
            setSearch(0);
            setIsSearch(0);
        }
        // eslint-disable-next-line
    }, [search]);

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, size, sortBy]);

    const handleSelectSavedCondition = (index) => {
        const item = savedConditions[index];
        if (!item) return;

        const { subwayPostStore, subwayNumStore, checkedLikeRightStoreValues, checkedStoreLabels, applyMethodStore } =
            item;

        setCheckedValues({ SubwayPost: subwayPostStore, SubwayNum: subwayNumStore });
        setCheckedLabels(checkedStoreLabels);
        setApplyMethod(applyMethodStore);

        const keywordSet = new Set();
        if (checkedLikeRightStoreValues && !checkedLikeRightStoreValues['RecruitClass']) {
            Object.values(checkedLikeRightStoreValues).forEach((keywords) => {
                keywords.forEach((keyword) => keywordSet.add(keyword));
            });
        }
        setKeywords([...keywordSet]);
    };

    useEffect(() => {
        setNum(getOptions(`SubwayNum00${activeTabIndex < 2 ? activeTabIndex + 1 : activeTabIndex + 2}`));
        // eslint-disable-next-line
    }, [activeTabIndex, dataSubway]);

    useEffect(() => {
        if (num && num.length > 0) {
            filterSubwayPost(num[0].value);
            setSelectedNum(num[0].value);
        }
        // eslint-disable-next-line
    }, [num]);

    const handleClickOutSidePopup = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            setSavedConditionsPopup(false);
        }
    };

    useEffect(() => {
        if (savedConditionsPopup) {
            document.addEventListener('mousedown', handleClickOutSidePopup);
            return () => {
                document.removeEventListener('mousedown', handleClickOutSidePopup);
            };
        }
    }, [savedConditionsPopup]);

    const openPopup = (data) => {
        if (decode?.authorities === 'ROLE_P') {
            setPopupData(data);
            setIsPopupOpen(true);
        } else if (decode?.authorities === 'ROLE_C') {
            window.alert('개인회원만 이용가능합니다.');
        } else {
            window.alert('로그인 후 이용가능합니다.');
        }
    };

    const closePopup = () => {
        setPopupData(null);
        setIsPopupOpen(false);
    };
    return (
        <>
            <div id="content">
                <Nav menu={MENU_RECRUIT} />
                <div id="tabs-form" className="container tabs-form-custom">
                    <div className="top-form">
                        <h2>역세권별</h2>
                        <div ref={popupRef}>
                            <button
                                id="saved-conditions"
                                data-type="popup"
                                onClick={() => {
                                    if (
                                        window.location.pathname !== '/login' &&
                                        window.location.pathname !== '/' &&
                                        !loggedIn
                                    ) {
                                        if (
                                            window.confirm(
                                                `회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`,
                                            )
                                        ) {
                                            navigate('/login');
                                        } else {
                                            alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                                            navigate('/');
                                        }
                                    }
                                    setSavedConditionsPopup(!savedConditionsPopup);
                                }}
                            >
                                <span>저장한 조건 보기</span>
                                <i className="icon icon-down" />
                            </button>
                            <div className={`popup ${savedConditionsPopup ? 'active' : ''}`} htmlFor="saved-conditions">
                                <button
                                    className="popup-close"
                                    onClick={() => {
                                        setSavedConditionsPopup(false);
                                    }}
                                />
                                <div className="popup-header">
                                    최근 저장한 검색 조건<span>(보관은 최대 5개까지 가능)</span>
                                </div>
                                <div className="popup-content">
                                    <ul className="table table-content">
                                        <li className="row-name-column">
                                            <div className="column start">검색조건</div>
                                            <div className="column start">검색일</div>
                                            <div className="column">삭제</div>
                                        </li>
                                        {savedConditions.map((item, index) => (
                                            <li key={index} onClick={() => handleSelectSavedCondition(index)}>
                                                <ul className="wrap-link">
                                                    {Array.isArray(item.checkedStoreLabels) &&
                                                        item.checkedStoreLabels.map((label, index) => (
                                                            <li key={index}>{label}</li>
                                                        ))}
                                                </ul>
                                                <span className="date">{item.savedStoreDate}</span>
                                                <button
                                                    className="delete"
                                                    onClick={() => {
                                                        dispatch(deleteFilterPAEAA014Conditions(index));
                                                        dispatch(saveMatchingConditions(decode.seq));
                                                    }}
                                                >
                                                    <i className="icon icon-trash"></i>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {activeTabIndex !== null && (
                        <div className="tab">
                            <div className="wrap-select-plus-child">
                                <div className="tabs-flex">
                                    <div className="tabs-left">
                                        <ul className={`tabs-custom`}>
                                            {tabs.map((tab, index) => (
                                                <li key={index} className={`${active === index ? 'active' : ''}`}>
                                                    <Link
                                                        to={location.pathname + location.search}
                                                        className={` ${React.isValidElement(tab.label) ? 'tab-search' : ''
                                                            }`}
                                                        onClick={() => handleTabClick(index)}
                                                    >
                                                        {tab.icon && <i className={`icon ${tab.icon}`} />}
                                                        {typeof tab.label === 'string' ? tab.label : tab.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                        <ul className="tab-check-box tab-checkbox-custom">
                                            {num &&
                                                num.length > 0 &&
                                                num.map((item, index) => {
                                                    return (
                                                        <li
                                                            className={
                                                                (checkedValues?.SubwayNum ?? []).includes(item.value) ||
                                                                    selectedNum === item?.value
                                                                    ? 'active'
                                                                    : ''
                                                            }
                                                            key={index}
                                                            onClick={() => handleNumClick(item.value)}
                                                        >
                                                            <span className="city-name">{item.label}</span>
                                                        </li>
                                                    );
                                                })}
                                        </ul>
                                    </div>
                                    <div className="tabs-right">
                                        <ul className="tab-check-box">
                                            <CheckBox
                                                name="SubwayPost"
                                                options={getOptions('SubwayPost')}
                                                onChange={handleInputChange}
                                                checked={checkedValues}
                                            />
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="tab-select-results">
                        <ul className="results-area">
                            {checkedLabels.map((label, index) => (
                                <li key={index}>
                                    <div className="item-search">{label}</div>
                                    <span
                                        className="item-remove icon icon-x"
                                        onClick={() => handleRemoveLabel(label)}
                                    ></span>
                                </li>
                            ))}
                        </ul>
                        <div className="wrap-option-search-block">
                            <button
                                onClick={handleSearchClick}
                                disabled={loading}
                                style={{
                                    position: 'relative',
                                    opacity: loading ? 0.85 : 1,
                                    transition: 'all 0.2s',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                }}
                            >
                                {loading ? (
                                    <>
                                        <span
                                            style={{
                                                display: 'inline-block',
                                                width: '14px',
                                                height: '14px',
                                                border: '2px solid rgba(255,255,255,0.4)',
                                                borderTop: '2px solid #fff',
                                                borderRadius: '50%',
                                                animation: 'spin 0.7s linear infinite',
                                                marginRight: '6px',
                                                verticalAlign: 'middle',
                                            }}
                                        />
                                        검색 중...
                                    </>
                                ) : searchSuccess ? (
                                    <>
                                        <span style={{ marginRight: '4px' }}>✓</span>
                                        검색 완료
                                    </>
                                ) : (
                                    <>
                                        선택한 조건으로<span>검색하기</span>
                                    </>
                                )}
                            </button>
                            <div className="wrap-option-search">
                                <div className="option-reset icon icon-reset" onClick={handleResetConditions}>
                                    조건 초기화
                                </div>
                                <div className="option-save icon icon-pin" onClick={handleSaveConditions}>
                                    조건 저장
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <GrandBanner />
                {/* Content Table */}
                <div id="support-now">
                    <div className="container">
                        <div className="wrap-table">
                            <div className="header-table-container">
                                <div className="top-table top-table--mt45">
                                    <div className="top-table-title">
                                        <h1>검색결과</h1>
                                        <span>Search Results 전체 {pages?.totalRow}건</span>
                                    </div>
                                    <div className="wrap-dropDown">
                                        <div className="count-results blue">즉시지원만 보기</div>
                                        <div className="dropDowns">
                                            <Dropdown
                                                placeholder=""
                                                options={[
                                                    { value: 'AddDate', option: '등록일순' },
                                                    { value: 'ModDate', option: '업데이트순' },
                                                    { value: 'RecruitEnd', option: '마감일순' },
                                                ]}
                                                name="sortBy"
                                                value={sortBy}
                                                onChange={handleOptionChange}
                                                className={'form-select-container--ver2'}
                                            />
                                            <Dropdown
                                                placeholder=""
                                                options={[
                                                    { value: 50, option: '50개씩 보기' },
                                                    { value: 80, option: '80개씩 보기' },
                                                    { value: 100, option: '100개씩 보기' },
                                                ]}
                                                name="size"
                                                value={size}
                                                onChange={handleOptionChange}
                                                className={'form-select-container--ver2'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="table table-header">
                                    <div className="column column-1">치과명</div>
                                    <div className="column column-3">
                                        <div>
                                            제목/담당업무/위치
                                        </div>
                                        <div>경력/형태/자격증/수정</div>
                                        <div>마감일</div>
                                    </div>
                                </div>
                            </div>
                            <RecruitList
                                loading={loading}
                                results={results}
                                recruitBanner={recruitBanner}
                                dataConFig={dataConFig}
                                openPopup={openPopup}
                                setRecruitList={setResults}
                                page={page}
                            />

                            <PaginationCustom pages={pages} />
                        </div>
                    </div>
                </div>
            </div>
            {isPopupOpen && <PAEAA060 popupData={popupData} closePopup={closePopup} />}
        </>
    );
};
export default PAEAA014;
